import { createFileRoute, redirect } from '@tanstack/react-router';

import { newRecommendationsSearchSchema } from 'components/NewRecommendations';
import { isPersonAdmin } from 'helpers/query';
import { userPipelineDetailsSearchSchema } from 'routes/_private/_route/users/$userId/pipelines/$pipelineId/index.route';

export const Route = createFileRoute(
  '/_private/_route/users/$userId/pipelines/$pipelineId/recommendations/new',
)({
  validateSearch: newRecommendationsSearchSchema,
  beforeLoad: ({ context, params }) => {
    // Adding recommendations is an admin-only action; everyone else goes back
    // to the pipeline detail page on the user surface.
    if (!isPersonAdmin(context.user)) {
      throw redirect({
        params: {
          pipelineId: params.pipelineId,
          userId: params.userId,
        },
        replace: true,
        search: userPipelineDetailsSearchSchema.parse({}),
        to: '/users/$userId/pipelines/$pipelineId',
      });
    }
  },
});
